import { render, staticRenderFns } from "./GoodsVideo.vue?vue&type=template&id=693aa5e8&scoped=true&"
import script from "./GoodsVideo.vue?vue&type=script&lang=js&"
export * from "./GoodsVideo.vue?vue&type=script&lang=js&"
import style0 from "./GoodsVideo.vue?vue&type=style&index=0&id=693aa5e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693aa5e8",
  null
  
)

export default component.exports